"use strict";

var _taggedTemplateLiteral = require("/home/circleci/top-up-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    grid-column-start: ", ";\n    grid-column-end: span ", ";\n    grid-row-start: ", ";\n    grid-row-end: span ", ";\n    justify-self: ", ";\n    align-self: ", ";\n  "]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    display: grid;\n    justify-items: ", ";\n    align-items: ", ";\n    align-content: ", ";\n\n    ", "\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.gridItem = exports.gridContainer = void 0;

var _core = require("@emotion/core");

var _mediaQueries = require("../../utils/mediaQueries");

var gridContainer = function gridContainer(_ref) {
  var container = _ref.container,
      justifyItems = _ref.justifyItems,
      alignItems = _ref.alignItems,
      alignContent = _ref.alignContent,
      rowGap = _ref.rowGap;
  return container && (0, _core.css)(_templateObject(), justifyItems, alignItems, alignContent, (0, _mediaQueries.mq)({
    gridTemplateColumns: ['repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(8, 1fr)', 'repeat(12, 1fr)', 'repeat(12, 1fr)'],
    gridColumnGap: ['8px', '8px', '8px', '16px', '24px', '24px'],
    gridRowGap: rowGap,
    padding: [[0, '20px'], [0, '20px'], [0, '24px'], [0, '40px'], [0, '71px'], [0, '252px']]
  }));
};

exports.gridContainer = gridContainer;

var gridItem = function gridItem(_ref2) {
  var item = _ref2.item,
      colStart = _ref2.colStart,
      colEnd = _ref2.colEnd,
      rowStart = _ref2.rowStart,
      rowEnd = _ref2.rowEnd,
      justifySelf = _ref2.justifySelf,
      alignSelf = _ref2.alignSelf;
  return item && (0, _core.css)(_templateObject2(), colStart, colEnd, rowStart, rowEnd, justifySelf, alignSelf);
};

exports.gridItem = gridItem;